const en = {
  common: {
    save: "Save",
    cancel: "Cancel",
    edit: "Edit",
    delete: "Delete",
    remove: "Remove",
    submit: "Submit",
    back: "Back",
    loading: "Loading...",
    search: "Search",
    yes: "Yes",
    no: "No",
    close: "Close",
    confirm: "Confirm",
    actions: "Actions",
    noData: "No data available",
    error: "An error occurred",
    success: "Success",
    required: "This field is required",
    invalidUrl: "Enter a valid URL",
    nonNegativeNumber: "Enter a whole number greater than or equal to 0",
    optional: "Optional",
    notSet: "Not set",
    descriptionHint:
      "Please be as detailed and comprehensive as possible. Include context, goals, expected behaviour, and any relevant constraints.",
  },
  nav: {
    dashboard: "Dashboard",
    newRequest: "New Request",
    requests: "Requests",
    inventory: "Inventory",
    newInventory: "New Inventory Item",
    users: "Users",
    profile: "Profile",
    admin: "Admin",
    language: "Language",
    help: "Help",
    manual: "User Manual",
    logout: "Logout",
  },
  requests: {
    title: "Title",
    description: "Description",
    audience: "Audience",
    audienceInternal: "Internal",
    audienceInternalInfo:
      "Choose this if the application is intended only for Rotoblaas employees. It will not be accessible from outside the company.",
    audienceExternal: "External",
    audienceExternalInfo:
      "Choose this if the application will be accessible to people outside Rotoblaas — for example via the company website, EService, or other public-facing tools.",
    departments: "Departments",
    needsErpIntegration: "Needs ERP Integration",
    needsErpIntegrationInfo:
      "Select this option if the application will need to exchange data or integrate with other group systems. Examples: Semiramis, Pimcore, EService, CRM.",
    participants: "Participants",
    participantsInfo: "Add participants you want notified when this request is created.",
    status: "Status",
    statusDraft: "Draft",
    statusNew: "Open",
    statusInProgress: "In Progress",
    statusCompleted: "Completed",
    responsibleDepartment: "Responsible Department",
    responsibleDepartmentIntegrations: "Integrations",
    responsibleDepartmentSoftwareDevelopment: "Software Development",
    responsibleDepartmentIct: "ICT",
    estimateDays: "Estimate (Days)",
    internalNotes: "Internal Notes",
    approvedBy: "Approved By",
    approvedAt: "Approved At",
    createdBy: "Created By",
    createdAt: "Created At",
    supervisor: "Supervisor",
    approve: "Approve",
    newRequest: "New Request",
    viewRequestPageTitle: "Request #{{id}}: {{title}}",
    editRequestPageTitle: "Edit: {{title}}",
    allRequests: "All Requests",
    backToRequests: "Back to Requests",
    backToRequest: "Back to Request",
    filterAll: "All",
    filterDraft: "Draft",
    filterNew: "New",
    filterInProgress: "In Progress",
    filterCompleted: "Completed",
    approveSuccess: "Request approved successfully",
    submitSuccess: "Request submitted successfully",
    updateSuccess: "Request updated successfully",
    managementSection: "Management Actions",
    auditTrail: "Audit Trail",
    deleteRequest: "Delete Request",
    confirmDeleteRequest: "Are you sure you want to delete this request? This action cannot be undone.",
    deleteSuccess: "Request deleted successfully",
    noRequests: "No requests found",
    typeLabel: "Capability Request",
  },
  inventory: {
    name: "Name",
    description: "Description",
    improvementNotes: "Improvement Notes",
    improvementNotesInfo:
      "Add any improvement points, ERP integrations, or anything you were unable to handle independently.",
    githubUrl: "GitHub URL",
    deploymentLocation: "Deployment Location",
    deploymentLocationInfo: "Where is the project saved or installed? E.g. SharePoint, local server…",
    audience: "Audience",
    audienceInternal: "Internal",
    audienceExternal: "External",
    participants: "Participants",
    status: "Status",
    statusUnderReview: "Under Review",
    statusTakenOver: "Taken Over",
    statusRejected: "Rejected",
    statusCompleted: "Completed",
    rejectCause: "Reject Cause",
    rejectCauseNotInteresting: "Not Interesting",
    rejectCauseDuplicate: "Duplicate",
    rejectCauseNonCompliant: "Non Compliant",
    rejectCauseOutOfScope: "Out of Scope",
    rejectCauseInsufficientInfo: "Insufficient Info",
    rejectCauseNotSustainable: "Not Sustainable",
    rejectCauseOther: "Other",
    rejectNote: "Reject Note",
    attachments: "Attachments",
    uploadAttachment: "Upload Attachment",
    addAttachment: "Add Attachment",
    noAttachments: "No attachments",
    attachmentUploadFailed: "Failed to upload one or more attachments. The item was not saved — please try again.",
    createdBy: "Created By",
    createdAt: "Created At",
    newItem: "New Inventory Item",
    allItems: "All Items",
    viewInventoryPageTitle: "Item #{{id}}: {{title}}",
    editInventoryPageTitle: "Edit Item #{{id}}: {{title}}",
    backToInventory: "Back to Inventory",
    backToInventories: "Back to Inventories",
    audienceExternalAlert:
      "External audience items must comply with HTML and JS constraints. Ensure all code meets web standards.",
    submitSuccess: "Inventory item submitted successfully",
    updateSuccess: "Inventory item updated successfully",
    managementSection: "Management",
    noItems: "No inventory items found",
    filterAll: "All",
    filterUnderReview: "Under Review",
    filterTakenOver: "Taken Over",
    filterRejected: "Rejected",
    filterCompleted: "Completed",
    fileSize: "Size",
    uploadedBy: "Uploaded by",
    uploadedAt: "Uploaded at",
    deleteAttachment: "Delete Attachment",
    confirmDeleteAttachment: "Are you sure you want to delete this attachment?",
  },
  notifications: {
    title: "Notifications",
    markAllRead: "Mark all read",
    markAsRead: "Mark as read",
    noNotifications: "No notifications",
    unread: "unread",
    seeAll: "See all notifications",
    filterAll: "All",
    filterUnread: "Unread",
    actions: {
      new_inventory_item: "added a new inventory item",
      request_approved: "approved a development request",
    },
  },
  profile: {
    language: "Language",
    manager: "Manager",
    noManager: "No manager assigned",
    english: "English (UK)",
    usEnglish: "English (US)",
    italian: "Italiano",
    french: "Français",
    german: "Deutsch",
    spanish: "Español",
    saveLanguage: "Save Language",
    languageSaved: "Language saved",
    title: "User Profile & Settings",
    personalInfo: "Personal Information",
    languageSettings: "Language Settings",
  },
  dashboard: {
    welcome: "Welcome",
    allRequests: "All Requests",
    allInventory: "All Items",
    myRequests: "My Requests",
    myInventory: "My Items",
    recentNotifications: "Recent Notifications",
    createRequest: "Create Request",
    createInventory: "Add Item",
    statusNew: "New",
    statusInProgress: "In Progress",
    statusCompleted: "Completed",
    statusToApprove: "To Approve",
    total: "Total",
  },
  users: {
    allUsers: "All Users",
    addUser: "Add User",
    name: "Name",
    firstName: "First Name",
    lastName: "Last Name",
    email: "Email",
    department: "Department",
    isAdmin: "Admin",
    lastAccess: "Last Access",
    noUsers: "No users found",
    addUserSuccess: "User added successfully",
    userNotFound: "User not found",
    confirmDelete: "Are you sure you want to delete this user?",
    roleAll: "All",
    roleAdmin: "Admin",
    roleNonAdmin: "Non-Admin",
    withAccess: "With Access",
    withoutAccess: "No Access",
  },
  admin: {
    title: "Admin",
    users: "Users",
    noAdminEndpoint: "Note: user role management is not yet available via the API.",
    email: "Email",
    name: "Name",
    isAdmin: "Admin",
    managerId: "Manager ID",
    createdAt: "Created At",
  },
};

export default en;
